<div class="filter-container"
     [@openClose]="filtersOpened && callLengthFilterOpened ? 'open' : 'closed'"
     (clickOutside)="exitFilter($event)">
  <div class="filter-header">
    <a href="#" (click)="backToFilters()">
      <i class="material-icons">arrow_back</i>
    </a>
    <div>{{translateFilterName(filter) | translate}}</div>
    <a href="#" (click)="filtersResign()"><i class="datatable-icon-close"></i></a>
  </div>
  <div class="filter-body">
    <div [formGroup]="rangeForm" class="full-width">
      <div formArrayName="rangesCollection" *ngFor="let item of rangesList; let i = index;" class="form-range-list-wrapper">
        <div [formGroupName]="i">
          <div class="filter-body-item">
            <a href="#" class="range-title">{{ 'CONTACTS_LIST.RANGE_NAME' | translate: {value: i+1} }}</a>
            <i class="datatable-icon-close" (click)="removeRange(item)"></i>
          </div>
          <div class="form-group-wrapper">
            <div class="filter-body-item">
              <span>{{'FROM' | translate}}</span>
              <div class="filter-form-wrapper" formGroupName="from">
                <mat-form-field class="filter-range-input-wrapper">
                  <input matInput placeholder="Input" type="number" min="0" max="59" max-length="2" min-length="1"
                         [placeholder]="0"
                         (input)="onChangeInput()"
                         formControlName="fromMin">
                  <mat-label>{{'MIN' | translate}}</mat-label>
                </mat-form-field>
                <span>:</span>
                <mat-form-field class="filter-range-input-wrapper">
                  <input matInput placeholder="Input" type="number" min="0" max="59" max-length="2" min-length="1"
                         [placeholder]="0"
                         (input)="onChangeInput()"
                         formControlName="fromSec">
                  <mat-label>{{'SEC' | translate}}</mat-label>
                </mat-form-field>
              </div>
            </div>
            <div class="filter-body-item">
              <span>{{'TO' | translate}}</span>

              <div class="filter-form-wrapper" formGroupName="to">
                <mat-form-field class="filter-range-input-wrapper">
                  <input matInput placeholder="Input" type="number" min="0" max="59" max-length="2" min-length="1"
                         [placeholder]="0"
                         (input)="onChangeInput()"
                         formControlName="toMin">
                  <mat-label>{{'MIN' | translate}}</mat-label>
                </mat-form-field>
                <span>:</span>
                <mat-form-field class="filter-range-input-wrapper">
                  <input matInput placeholder="Input" type="number" min="0" max="59" max-length="2" min-length="1"
                         [placeholder]="0"
                         (input)="onChangeInput()"
                         formControlName="toSec">
                  <mat-label>{{'SEC' | translate}}</mat-label>
                </mat-form-field>
              </div>
              <mat-error class="filter-range-input-error"
                         *ngIf="hasRangeErrors(i)">{{'CONTACTS_LIST.CALL_LENGTH_ERROR' | translate}}
              </mat-error>
            </div>
          </div>
        </div>
      </div>

      <div class="filter-body-item filter-item-button item-transparent">
        <button class="add-range-button" (click)="addNewRange()">{{'CONTACTS_LIST.ADD_NEXT_RANGE' | translate}}</button>
      </div>
    </div>
  </div>
  <div class="filter-footer" (click)="callLengthsFiltersDone()">
    <button class="accept-button" [disabled]="!isFilteringReady">{{'DONE' | translate}}</button>
  </div>
</div>
